import { getRouteApi, useNavigate, useParams } from "@tanstack/react-router"

import { Button } from "@workspace/web-ui/components/button"
import { ArrowLeft, FileX } from "lucide-react"

import { useQuery } from "@tanstack/react-query"
// import { EncounterDetailsContent } from "../components/encounter-details";
import { encounterByIdQueryOptions } from "../api/queries";
import { EncounterDetailsAction } from "../components/encounter-details-action/encounter-details-action";
import { getApiProgram } from "~/lib/utils";
import { useSearch } from "@tanstack/react-router";
import { patientDetailsQueryOptions } from "../../patient-logs/api/queries";


function PatientLogDetailsSkeleton() {
    return (
        <section
            role="main"
            aria-label="Patient Log Loading"
            className="mx-auto flex flex-1 w-full max-w-[900px] justify-center items-start px-[80px] gap-[52px] max-lg:hidden py-[24px] animate-pulse"
        >
            <div className="flex flex-col gap-5 w-full">
                {/* Back button skeleton */}
                <div className="h-10 w-24 bg-gray-200 rounded-sm" />

                <div className="flex gap-2 items-center w-full">
                    <div className="flex flex-col gap-4 w-full">
                        {/* Patient name skeleton */}
                        <div className="h-8 w-1/3 bg-gray-200 rounded" />
                        {/* Patient info skeleton */}
                        <div className="flex flex-col gap-3">
                            <div className="flex flex-wrap items-center gap-2">
                                <div className="h-4 w-20 bg-gray-200 rounded" />
                                <div className="h-4 w-12 bg-gray-200 rounded" />
                                <div className="h-4 w-10 bg-gray-200 rounded" />
                            </div>
                            <div className="flex flex-wrap items-center gap-4">
                                <div className="h-6 w-24 bg-gray-200 rounded" />
                                <div className="h-6 w-24 bg-gray-200 rounded" />
                            </div>
                        </div>
                        {/* Tabs skeleton */}
                        <div className="flex flex-col gap-4 mt-5 w-full">
                            <div className="flex w-full items-start justify-start overflow-x-auto hide-scrollbar py-1 px-0 bg-transparent border-b gap-1 md:gap-2">
                                {[...Array(6)].map((_, i) => (
                                    <div key={i} className="h-8 w-20 bg-gray-200 rounded-t-md flex-shrink-0 flex-grow-0" />
                                ))}
                            </div>
                            {/* Tab content placeholder - PatientLogTabs handles its own skeleton for content */}
                            <div className="w-full mt-4">
                                <div className="h-64 w-full bg-gray-200 rounded" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export function EncounterDetailsPage() {
    const navigate = useNavigate()
    const { id } = useParams({ from: "/(dashboard)/dashboard/$program/encounters/encounter/$id" })
    const { patientId } = useSearch({ from: "/(dashboard)/dashboard/$program/encounters/encounter/$id" })
    const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
    const { program } = routeApi.useParams();
    const apiProgram = getApiProgram(program ?? "");
    const { data: patientSummary } = useQuery(patientDetailsQueryOptions(patientId ?? "", program ?? ""))
    
    // const { data: patientSummary, isLoading } = useQuery(patientDetailsQueryOptions(id))
    const { data: encounter, isLoading } = useQuery(encounterByIdQueryOptions(id, apiProgram ?? ""))

    const handleBack = () => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            navigate({ to: "/dashboard/$program", replace: false, params: { program } });
        }
    }

    // Show skeleton loading
    if (isLoading) {
        return (<PatientLogDetailsSkeleton />)
    }

    return (
        <section
            aria-label="Quick Actions Overview"
            className="mx-auto  flex flex-1 w-full max-w-[900px] justify-center items-start px-[10px] gap-[52px] py-[24px]">

            <div className="flex flex-col gap-5 w-full">
                {program !== "urgent-care" && encounter?.type && ["consultation", "appointment", "refill", "live-consultation", "live consultation"].includes(encounter.type) && (
                <Button
                    onClick={handleBack}
                    variant="outline"
                    className="w-fit flex items-center gap-2 text-gray-600 hover:text-gray-900 mr-auto px-[16px] py-[10px] rounded-sm"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Back
                </Button>
                )}
                {encounter ? (
                    <EncounterDetailsAction className="w-full" encounter={encounter} patientSummary={patientSummary} program={program} />
                ) : (
                    <div className="flex flex-col items-center justify-center py-16 px-4">
                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                            <FileX className="w-8 h-8 text-gray-400" />
                        </div>
                        <h3 className="text-lg font-medium text-gray-900 mb-2">No encounter found</h3>
                        <p className="text-sm text-gray-500 text-center max-w-md">
                            The encounter you're looking for could not be found or may have been removed.
                        </p>
                    </div>
                )}

                {/* <div className="flex gap-2 items-center w-full">

                    <div className="flex flex-col gap-4 w-full">
                        <div className="flex flex-col gap-4 w-full">
                            <h1 className="text-[32px] font-semibold">
                                {typeof name === "string"
                                    ? name
                                        .split(/(?=[A-Z][a-z])|[\s]+/) // split on spaces or camel case
                                        .filter(Boolean)
                                        .join(" ")
                                    : name}
                            </h1>
                            {patientSummary && <PatientInfo patient={patientSummary} />}
                        </div>
                        <div className="flex flex-col gap-4 mt-5 w-full">
                            <PatientLogTabs userId={id} />
                        </div>
                    </div>
                </div> */}
            </div>
        </section>
    )
}